import { render, staticRenderFns } from "./Dashboard-cadeaux.vue?vue&type=template&id=4b64c550&"
import script from "./Dashboard-cadeaux.vue?vue&type=script&lang=js&"
export * from "./Dashboard-cadeaux.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-cadeaux.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports